module.exports = __webpack_public_path__ + "assets/img/lvbang.03df5697.png";